<app-offcanvas-sheet
  [visible]="visible"
  [title]="title"
  (closeCanvas)="onClose()"
  (save)="onSave()">

  <!-- Variable Cost -->
  <ng-container *ngIf="mode === 'variable'">
    <div class="form-group-mobile">
      <label>Variable Cost Name</label>
      <app-single-select-dropdown
        [options]="variableOverheadOptions"
        [selectedValue]="editData.overhead ?? null"
        placeholder="Select Variable Cost"
        [allowAddNew]="true"
        [addNewLabel]="'Custom Variable Cost'"
        (selectedValueChange)="editData.overhead = $event"
        (addMore)="editData.overhead = 'custom'">
      </app-single-select-dropdown>
      <input *ngIf="editData.overhead === 'custom'"
        type="text" class="form-control mt-2"
        [(ngModel)]="editData.customOverhead"
        placeholder="Custom Variable Cost Name" />
    </div>
    <div class="form-group-mobile">
      <label>Unit of Measurement</label>
      <app-single-select-dropdown
        [options]="uomOptions"
        [selectedValue]="editData.uomID != null ? editData.uomID.toString() : null"
        placeholder="Select Unit of Measurement"
        (selectedValueChange)="editData.uomID = $event ? +$event : null">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Purchase Price (R)</label>
      <input type="number" inputmode="decimal" class="form-control"
        [(ngModel)]="editData.purchasePrice" min="0" />
    </div>
    <div class="form-group-mobile">
      <label>Purchase Quantity</label>
      <input type="number" inputmode="decimal" class="form-control"
        [(ngModel)]="editData.purchaseQuantity" min="0" />
    </div>
  </ng-container>

  <!-- Fixed Cost -->
  <ng-container *ngIf="mode === 'fixed'">
    <div class="form-group-mobile">
      <label>Fixed Cost Name</label>
      <app-single-select-dropdown
        [options]="fixedOverheadOptions"
        [selectedValue]="editData.overhead ?? null"
        placeholder="Select Fixed Cost"
        (selectedValueChange)="editData.overhead = $event">
      </app-single-select-dropdown>
      <input *ngIf="editData.overhead === 'custom'"
        type="text" class="form-control mt-2"
        [(ngModel)]="editData.customOverhead"
        placeholder="Custom Fixed Cost Name" />
    </div>
    <div class="form-group-mobile">
      <label>Cost (R)</label>
      <input type="number" inputmode="decimal" class="form-control"
        [(ngModel)]="editData.cost" min="0" />
    </div>
    <div class="form-group-mobile">
      <label>Payment Period</label>
      <app-single-select-dropdown
        [options]="periodTypeOptions"
        [selectedValue]="editData.periodTypeID != null ? editData.periodTypeID.toString() : null"
        placeholder="Select Period"
        (selectedValueChange)="editData.periodTypeID = $event ? +$event : null">
      </app-single-select-dropdown>
    </div>
  </ng-container>

  <!-- Salary -->
  <ng-container *ngIf="mode === 'salary'">
    <div class="form-group-mobile">
      <label>Employee</label>
      <app-single-select-dropdown
        [options]="employeeOptions"
        [selectedValue]="editData.employeeID != null ? editData.employeeID.toString() : null"
        placeholder="Select Employee"
        (selectedValueChange)="editData.employeeID = $event ? +$event : null">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Amount (R)</label>
      <input type="number" inputmode="decimal" class="form-control"
        [(ngModel)]="editData.amount" min="0" />
    </div>
    <div class="form-group-mobile">
      <label>Payment Rate Type</label>
      <app-single-select-dropdown
        [options]="periodTypeOptions"
        [selectedValue]="editData.periodTypeID != null ? editData.periodTypeID.toString() : null"
        placeholder="Select Period"
        (selectedValueChange)="editData.periodTypeID = $event ? +$event : null">
      </app-single-select-dropdown>
    </div>
    <div class="form-group-mobile">
      <label>Hours Worked / Month</label>
      <input type="number" inputmode="decimal" class="form-control"
        [(ngModel)]="editData.hoursWorked" min="0" />
    </div>
  </ng-container>

  <!-- Employee -->
  <ng-container *ngIf="mode === 'employee'">
    <div class="form-group-mobile">
      <label>First Name</label>
      <input type="text" class="form-control"
        [(ngModel)]="editData.firstName" placeholder="First name" />
    </div>
    <div class="form-group-mobile">
      <label>Last Name</label>
      <input type="text" class="form-control"
        [(ngModel)]="editData.lastName" placeholder="Last name" />
    </div>
    <div class="form-group-mobile">
      <label>Role</label>
      <app-single-select-dropdown
        [options]="roleOptions"
        [selectedValue]="editData.roleID != null ? editData.roleID.toString() : null"
        placeholder="Select Role"
        (selectedValueChange)="editData.roleID = $event ? +$event : null">
      </app-single-select-dropdown>
    </div>
  </ng-container>

</app-offcanvas-sheet>
